import portfolioService from '../../services/portfolioService'

const INITIAL_PORTFOLIO = {
  id: null,
  stats: null,
  assets: null,
  transactions: null,
  transactionsTotal: null,
}

const state = {
  selectedPortfolio: {...INITIAL_PORTFOLIO},
  totalPortfolios: {...INITIAL_PORTFOLIO},
  updateTime: null,
}

const getters = {
  getUpdateTime(state) {
    return state.updateTime
  },
  // Selected Portfolio (SP)
  getSPStats(state) {
    return state.selectedPortfolio.stats
  },
  getSPAssets(state) {
    return state.selectedPortfolio.assets
  },
  getSPTransactions(state) {
    return state.selectedPortfolio.transactions
  },
  getSPTransactionsTotal(state) {
    return state.selectedPortfolio.transactionsTotal
  },
  // Total Portfolios (TP)
  getTPStats(state) {
    return state.totalPortfolios.stats
  },
  getTPAssets(state) {
    return state.totalPortfolios.assets
  },
}

const mutations = {
  // Selected Portfolio (SP)
  selectPortfolio(state, payload) {
    if (state.selectedPortfolio.id !== payload) {
      // Set a new portfolio or none
      const id = payload || INITIAL_PORTFOLIO.id
      state.selectedPortfolio = Object.assign({}, INITIAL_PORTFOLIO, {id})
    }
  },
  setSPDetails(state, payload) {
    var selectedPortfolio = state.selectedPortfolio
    if (selectedPortfolio.id === payload.id) {
      selectedPortfolio.stats = payload.stats
      selectedPortfolio.assets = payload.assets
      state.updateTime = payload.updateTime
    } else {
      console.error('Selected portfolio is different.')
    }
  },
  setSPTransactions(state, payload) {
    var selectedPortfolio = state.selectedPortfolio
    if (selectedPortfolio.id === payload.id) {
      selectedPortfolio.transactions = selectedPortfolio.transactions || []
      selectedPortfolio.transactions[payload.page] = payload.transactions
      selectedPortfolio.transactionsTotal = payload.total
    } else {
      console.error('Selected portfolio is different.')
    }
  },
  // Total Portfolios (TP)
  setTotalPortfolios(state, payload) {
    state.totalPortfolios = payload
    state.updateTime = payload.updateTime
  },
}

const actions = {
  // Selected Portfolio (SP)
  loadPortfolioDetails({ commit }, portfolioId) {
    const selectedPortfolio = state.selectedPortfolio
    if (selectedPortfolio.id === portfolioId && selectedPortfolio.assets && selectedPortfolio.stats) {
      return Promise.resolve()
    }

    commit('selectPortfolio', portfolioId)

    return portfolioService.getPortfolioDetails(portfolioId)
      .then(data => {
        commit('setSPDetails', data)
        return data
      })
      .catch(errObj => Promise.reject(errObj.error))
  },
  loadPortfolioTransactions({ commit, state }, {portfolioId, page, itemsPerPage}) {
    const selectedPortfolio = state.selectedPortfolio
    if (selectedPortfolio.id === portfolioId && selectedPortfolio.transactions && selectedPortfolio.transactions[page]) {
      return Promise.resolve()
    }

    page = page || 1
    const limit = itemsPerPage || 20
    const offset = limit * (page - 1)

    commit('selectPortfolio', portfolioId)

    return portfolioService.getPortfolioTransactions(portfolioId, offset, limit)
      .then(res => {
        let payload = {
          id: portfolioId,
          page,
          transactions: res.transactions,
          total: res.total,
        }
        commit('setSPTransactions', payload)
        return payload
      })
      .catch(errObj => Promise.reject(errObj.error))
  },
  // Total Portfolios (TP)
  loadTotalPortfolios({ commit }) {
    return portfolioService.getTotalPortfolios()
      .then(data => {
        commit('setTotalPortfolios', data)
        return data
      })
      .catch(errObj => Promise.reject(errObj.error))
  },
  // !! FOR TESTING PURPOSES ONLY
  deleteAllTransactions({ commit, state }) {
    return portfolioService.deleteAllTransactions()
      .then(() => {
        commit('selectPortfolio', state.selectedPortfolio.id)
        commit('setTotalPortfolios', Object.assign({}, INITIAL_PORTFOLIO))
      })
  },
  exportAllTransactions({ commit, state }) {
    return portfolioService.exportAllTransactions()
      .then(data => {
        return data
      })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/-service-app/store/modules/portfolioStore.js